import {
  DeleteOutlined,
  DownOutlined,
  PlayCircleOutlined,
  PlusOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { App, Avatar, Button, Dropdown, Tooltip, Typography } from "antd";
import { useActionDraftSpeaker } from "hook/draft/dialog/useActionDraftSpeaker";
import moment from "moment";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { setDraftDialogKick } from "store/bailiff/draft/dialog/draft_dialog.action";
import { draftDialogSpeakersSelector } from "store/bailiff/draft/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const PreviewSpeakers = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  const { handleChangeSpeakerName, handleDeleteSpeaker } =
    useActionDraftSpeaker();
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "not_edit";
  // -------------------------- STATE ---------------------------
  const [hover, setHover] = useState(false);
  const [key, setKey] = useState(null);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const speakers = useSelector(draftDialogSpeakersSelector);
  const total = speakers?.length || 0;
  // -------------------------- FUNCTION ------------------------
  const handleSelect = (second) => {
    const id = `change-${moment()?.valueOf()}-${second}`;
    dispatch(setDraftDialogKick(id));
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderDropdown = () => {
    return (
      <div className="flex min-h-[100px] min-w-[150px] flex-col bg-white p-1 shadow-md">
        {speakers?.map((item) => {
          const deleted = item?.delete || false;
          return (
            <div
              onMouseEnter={() => {
                setHover(true);
                setKey(item?.key);
              }}
              onMouseLeave={() => {
                setHover(false);
                setKey(null);
              }}
              className="flex cursor-pointer items-center hover:bg-gray-200"
              key={item?.key}
            >
              <Avatar
                style={{ background: "transparent" }}
                shape="circle"
                icon={
                  <UserOutlined
                    className="rounded-full"
                    style={{ background: item?.color }}
                  />
                }
              />
              <Typography.Text
                editable={{
                  onChange: (newLabel) => {
                    if (!newLabel)
                      return message.error("Không được để trống tên");
                    if (!key) return;
                    handleChangeSpeakerName(key, newLabel);
                  },
                }}
                style={{ maxWidth: 150 }}
                className="text-gray-700"
              >
                {item?.label}
              </Typography.Text>
              {deleted && (
                <Tooltip title="Delete">
                  <Button
                    onClick={() => handleDeleteSpeaker(key)}
                    danger
                    type="link"
                    size="small"
                    icon={<DeleteOutlined />}
                  />
                </Tooltip>
              )}
              {renderPlay(item)}
            </div>
          );
        })}
        <div>
          <Button
            onClick={() => setSearchParams({ tab, viewSpeakerAdd: true })}
            type="text"
            block
            className="rounded-sm p-2 text-blue-600"
            icon={<PlusOutlined />}
          >
            Speaker
          </Button>
        </div>
      </div>
    );
  };

  const renderPlay = (item) => {
    const chosen = key === item?.key;
    const from = item?.from || 0;
    if (!hover || !chosen) return null;
    return (
      <>
        <Button
          onClick={() => handleSelect(from)}
          size="small"
          type="text"
          className="rounded-sm p-2 text-blue-600"
          icon={<PlayCircleOutlined />}
        >
          Nghe
        </Button>
      </>
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Dropdown dropdownRender={() => renderDropdown()} trigger={["click"]}>
      <Button iconPosition="end" icon={<DownOutlined />}>
        {total} Speakers
      </Button>
    </Dropdown>
  );
};
export default PreviewSpeakers;
